import { registerEntityEndpoint as e } from "@editor/ui-utils";
//#region \0plugin-vue:export-helper
var t = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, n = "Images", r = e(n), { getEntity: i, listEntities: a, postEntity: o, putEntity: s, deleteEntity: c, getEntityAPIClient: l } = r, u = async (e = null) => a({ params: { search: e || null } }), d = {
	_id: void 0,
	createDate: void 0,
	changeDate: void 0,
	isDeleted: void 0,
	source: void 0
}, f = async (e, t = !1) => i(e, { params: { includePreview: t } }), p = (e, t = 640, n = 360) => `${l().defaults.baseURL}/${e}/url/${t}/${n}`, m = async (e) => o({
	...e,
	...d
}), h = async (e, t) => s(e, {
	...t,
	...d
}), g = async (e, t) => {
	let n = {
		...e,
		...d
	}, r = new FormData();
	return r.append("image", JSON.stringify(n)), r.append("file", t), o(r, { headers: { "content-type": "multipart/form-data" } });
}, _ = async (e, t) => {
	let n = {
		...e,
		...d
	}, r = new FormData();
	return r.append("image", JSON.stringify(n)), r.append("file", t), s(`${e._id}/replace`, r, { headers: { "content-type": "multipart/form-data" } });
}, v = async (e) => {
	let t = {
		...e,
		...d
	};
	return s(e._id || "", t);
}, y = async (e) => c(e._id), b = () => ({
	type: "IMAGE",
	imageUuid: "",
	imageLinkOutUrl: "",
	hasNoFollow: !1,
	hasAffiliate: !1,
	hasNewTab: !1,
	hasFullSizeView: !1
}), x = () => ({
	type: "TWO_IMAGES",
	imageLayout: "DOUBLE_PICTURE",
	leftImageUuid: "",
	rightImageUuid: "",
	leftImageLinkOutUrl: "",
	rightImageLinkOutUrl: "",
	leftLabel: "",
	rightLabel: "",
	hasNoFollow: !1,
	hasAffiliate: !1,
	hasNewTab: !1
});
//#endregion
export { v as a, f as c, _ as d, h as f, y as i, p as l, t as m, r as n, b as o, g as p, m as r, x as s, n as t, u };

//# sourceMappingURL=image.service-BZ-WQOP-.js.map